
import Button from '../storyblok/Button.vue'
import RichText from '../common/RichText.vue'
export default {
  name: 'Hero',
  components: { Button, RichText },
  props: {
    blok: Object,
    location: Object
  },
  computed: {
    isMobile() {
      return this.$mq == 'sm' || this.$mq == 'md' ? true : false
    },
    heroVariants() {
      return [
        { 'title-only': this.title
                     && !this.hasCTA
                     && !this.blok.sub_text
                     && !this.blok.subtitle
                     && !this.hasCopyContent
        },
        { 'has-hero-detail': this.blok.hero_detail },
      ]
    },
    bgVariants() {
      return [
        this.blok.background_color ? `bg--${this.blok.background_color}` : 'bg--red',
        this.blok.space_around ? `space-around--${this.blok.space_around}` : '',
        this.blok.space_around_mobile ? `space-around-mobile--${this.blok.space_around_mobile}` : '',
        { 'fill-page': this.blok.fill_page },
      ]
    },
    alignVariants() {
      let variants = '';
      if(this.blok.mobile_alignment) {
        variants += ` align-mobile--${this.blok.mobile_alignment}`
      }
      if(this.blok.desktop_alignment) {
        variants += ` align-desktop--${this.blok.desktop_alignment}`
      }
      return variants
    },
    colorVariants() {
      if (['yellow', 'bright-green', 'teal'].includes(this.blok.background_color)) {
        return 'black'
      }
      return 'white'
    },
    sizeVariants() {
      if (this.isMobile) {
        return 'small'
      }
      return ''
    },
    image() {
      if (this.isMobile && this.blok.mobile_image && this.blok.mobile_image.filename) {
        return this.blok.mobile_image
      }
      return this.blok && this.blok.image ? this.blok.image : {}
    },
    imageVariant() {
      return { 'variant--mobile': this.isMobile && this.blok.mobile_image && this.blok.mobile_image.filename }
    },
    hasCTA() {
      return this.blok.cta?.length > 0
    },
    hasCopyContent() {
      return this.blok.copy_content?.content[0].content?.length > 0
    }
  },
  methods:{
    orderNow() {
      const to = this.location && this.location.menu_id
          ? `/menu/${this.location.menu_id}`
          : `/locations`
      this.$router.push(to);
    },
    handleClick(event) {
      if(!event) return;
      try {
        this[event]()
      } catch(err) {
        console.error(`The event "${event}" has no method in this component!`, err)
      }
    }
  }
}
